export default __webpack_public_path__ + "static/media/icon_resurssit_aloitettu.1186b07f.svg";